import { createContext, useContext, useMemo } from 'react';
import { defineAbilityFor, type AppAbility } from '../features/permissions';
import { Permission } from '../shared';

const AbilityContext = createContext<AppAbility | null>(null);

export const useAbility = () => useContext(AbilityContext);

export function AbilityProvider({
  permission,
  children,
}: {
  permission: Permission;
  children: React.ReactNode;
}) {
  const ability = useMemo(() => defineAbilityFor(permission), [permission]);
  return <AbilityContext.Provider value={ability}>{children}</AbilityContext.Provider>;
}
